import { Tooltip } from '@affine/component/ui/tooltip';
import { useI18n } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';
import { type SyntheticEvent, useEffect } from 'react';

import { ServerService, SubscriptionService } from '../../../modules/cloud';
import * as styles from './style.css';
import { usePlanBadge } from './use-plan-badge';

export const UserPlanButton = ({
  onClick,
}: {
  onClick: (e: SyntheticEvent<Element, Event>) => void;
}) => {
  const serverService = useService(ServerService);
  const subscriptionService = useService(SubscriptionService);

  const hasPayment = useLiveData(
    serverService.server.features$.map(r => r?.payment)
  );
  const plan = useLiveData(
    subscriptionService.subscription.pro$.map(subscription =>
      subscription !== null ? subscription?.plan : null
    )
  );
  const badge = usePlanBadge();
  const isLoading = plan === null;

  useEffect(() => {
    // revalidate subscription to get the latest status
    subscriptionService.subscription.revalidate();
  }, [subscriptionService]);

  const t = useI18n();

  if (!hasPayment) {
    // no payment feature
    return;
  }

  if (isLoading) {
    // loading, do nothing
    return;
  }

  return (
    <Tooltip content={t['com.affine.payment.tag-tooltips']()} side="top">
      <div
        data-is-believer={badge.isBeliever ? 'true' : undefined}
        data-is-pro={badge.isPro ? 'true' : undefined}
        data-tier={badge.tier}
        className={styles.userPlanButton}
        onClick={onClick}
      >
        {badge.label}
      </div>
    </Tooltip>
  );
};
